<template>
  <div class="review">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toGoodsPromotion">活动竞价/</span>
        {{ title }}
      </template>
      <template v-slot:content>
        <div class="review-main">
          <div class="table" ref="steps">
            <el-table :data="addTableData" style="width: 100%" :span-method="objectSpanMethod">
              <el-table-column
                prop="goodsName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                prop="specifications"
                label="商品规格"
              ></el-table-column>
              <el-table-column label="当前竞价金额">
                <template slot-scope="scope">
                  <p>{{biddingPrice}}</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="promotionNum"
                label="促销数量"
              ></el-table-column>
            </el-table>
          </div>
          <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
            <el-form-item label="促销规则：" prop="rule">
              <el-radio-group v-model="ruleForm.rule" :disabled="disabled">
                <el-radio :label="1">
                  <span>商品直降</span>
                  <el-input
                    :disabled="disabled"
                    class="white"
                    @input="changeReducePrice(reducePrice)"
                    v-model="reducePrice"
                  ></el-input>
                  <span>元</span>
                </el-radio>
                <el-radio :label="2">
                  <p>阶梯促销</p>
                </el-radio>
              </el-radio-group>
              <ul class="ladderlist">
                <li
                  class="ladderlist-child"
                  v-for="(value, index) in ladderPromotionData"
                  :key="index"
                >
                  <span>订单数量满</span>
                  <el-input
                    :disabled="disabled"
                    class="white"
                    @input="changeOrderNum(index, value.num)"
                    @blur="watchOrderNum(index, value.num)"
                    v-model="value.num"
                  ></el-input
                  >,商品价统一减￥
                  <el-input
                    :disabled="disabled"
                    class="white"
                    @input="changeOrderPrice(index, value.price)"
                    v-model="value.price"
                  ></el-input>
                  <el-button
                    v-if="index > 0 && !disabled"
                    type="text"
                    class="btn-text"
                    :disabled="disabled"
                    @click="deleteLadderPromotion(index)"
                    >删除</el-button
                  >
                </li>
              </ul>
              <!-- <p class="addLi">
                <el-button
                  type="text"
                  class="btn-text"
                  :disabled="disabled"
                  @click="addLadderPromotion"
                  >+添加区间</el-button
                >
              </p> -->
            </el-form-item>
            <el-form-item label="每人限购：">
              <el-input
                :disabled="disabled"
                v-model="ruleForm.scopeNum"
                @input="changeScopeNum(ruleForm.scopeNum)"
                class="white w160"
                placeholder="请输入数量"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="bottom">
            <div class="operations" ref="operations">
              <el-button v-if="isReview == 1" class="btn-white" @click="goBack">返回</el-button>
              <el-button v-if="isReview == 2" class="btn-white" @click="cancel">拒绝</el-button>
              <el-button v-if="isReview == 2" class="btn-blue" @click="adopt"
                >通过</el-button
              >
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationModul from "base/PaginationTpl";
import DBBiddingActivities from "models/db/biddingActivities.js";
const dbBiddingActivities = new DBBiddingActivities();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationModul
  },
  data() {
    return {
      id: "",
      title: "审核商品",
      goodsId: "",
      disabled: true,
      // 选取的商品sku
      addTableData: [],
      ruleForm: {
        scopeNum: "",
        rule: 1,
      },
      reducePrice: "",
      ladderPromotionData: [
        {
          num: "",
          price: "",
        },
      ],
      isReview: 0
    };
  },
  created() {
    let id = this.$route.query.id;
    this.id = id;
    if (id) {
      this.disabled = true;
      this.isReview = this.$route.query.isReview
      this.getPromotionDetail();
    }
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      if (this.$refs.operations) {
        this.$refs.operations.style.width =
          this.$refs.steps.clientWidth + paddingWidth + "px";
      }
    };
  },
  methods: {
    toGoodsPromotion() {
      this.$router.push(
        "/admin/marketing/bidding-activities/biddingActivities"
      );
    },
    // 获取促销详情
    getPromotionDetail() {
      let id = this.id;
      dbBiddingActivities.getDBBiddingGoodsInfo(id).then((res) => {
        if (res.success) {
          this.goodsId = res.result.goodsId;
          this.ruleForm.scopeNum = res.result.buyLimit;
          this.ruleForm.rule = res.result.ruleType;
          if (this.ruleForm.rule === 1) {
            this.reducePrice = res.result.descend;
          } else if (this.ruleForm.rule === 2) {
            let arr = [];
            res.result.ladderJson.map((value) => {
              let obj = {};
              obj.num = value.full;
              obj.price = value.reduce;
              arr.push(obj);
            });
            this.ladderPromotionData = arr;
          }
          this.biddingPrice = res.result.biddingPrice
          res.result.promotionDetail.map((value) => {
            let obj = {};
            obj.goodsName = res.result.goodsName;
            obj.id = value.itemId;
            let str = "";
            Object.keys(value.specInfo).forEach((key) => {
              str += value.specInfo[key] + " ;";
            });
            obj.specifications = str.slice(0, str.length - 1);
            obj.price = value.marketPrice;
            obj.promotionNum = value.num;
            obj.saleNum = value.saleNum;
            this.addTableData.push(obj);
          });
        }
      });
    },
    // 限制数量
    changeScopeNum(num) {
      this.ruleForm.scopeNum = this.regNum(num);
    },
    // 限制商品直降价钱
    changeReducePrice(price) {
      this.reducePrice = this.regPrice(price);
    },
    // 限制阶梯促销数量
    changeOrderNum(index, num) {
      this.$set(this.ladderPromotionData[index], "num", this.regNum(num));
    },
    // 限制阶梯促销价钱
    changeOrderPrice(index, price) {
      this.$set(this.ladderPromotionData[index], "price", this.regPrice(price));
    },
    // 判断当前数是否比上一个数大
    watchOrderNum(index, num) {
      if (index > 0) {
        if (
          Number(num) <= Number(this.ladderPromotionData[index - 1].num) ||
          this.ladderPromotionData[index - 1].num === ""
        ) {
          this.$set(this.ladderPromotionData[index], "num", "");
          this.$message.error("当前数量必须必前一个数大");
        }
      }
    },
    // 正整数输入
    regNum(num) {
      let retailNum = num.toString().match(/^\d*/g)
        ? num === "0"
          ? ""
          : num.toString().match(/^\d*/g)[0]
        : "";
      return retailNum;
    },
    // 价钱输入
    regPrice(price) {
      let RetailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      return RetailPrice;
    },
    // 添加阶梯促销
    addLadderPromotion() {
      if (this.ladderPromotionData.length < 5) {
        let obj = {
          num: "",
          price: "",
        };
        this.ladderPromotionData.push(obj);
      } else {
        this.$message.error("最多添加5个阶梯促销");
      }
    },
    // 删除阶梯促销
    deleteLadderPromotion(index) {
      this.ladderPromotionData.splice(index, 1);
    },
    // 通过
    adopt() {
      this.review(2, '')
    },
    review(isPass, message) {
      let data = {}
      data.id = Number(this.id)
      data.isPass = isPass
      data.message = message
      dbBiddingActivities.getDBBiddingGoodsReview(data).then(res => {
        if (res.success) {
          this.$message({
            message: '审核成功',
            center: true,
            type: 'success',
            duration: 1000
          });
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      })
    },
    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        let length = this.addTableData.length + 1;
        if (rowIndex % length === 0) {
          return {
            rowspan: length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 拒绝
    cancel() {
      this.$confirm('理由：', '拒绝理由', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showInput: true,
        inputType: 'textarea',
        customClass: 'review-messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
        inputPlaceholder: '请输入拒绝理由'
      }).then(({ value }) => {
        this.review(3, value)
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
};
</script>

<style lang="scss" scoped>
.review {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .review-main {
    .add-clear {
      height: 32px;
    }
    .el-form {
      width: 500px;
      margin-top: 20px;
      .el-radio-group {
        display: flex;
        flex-direction: column;
        .el-radio {
          align-items: center;
          display: flex;
          min-height: 32px;
          .el-input {
            width: 80px;
            margin: 0 10px;
          }
        }
      }
      .ladderlist {
        font-size: 14px;
        color: #999999;
        padding-left: 24px;
        .ladderlist-child {
          display: flex;
          .el-button {
            margin-left: 10px;
          }
        }
      }
      .addLi {
        padding-left: 24px;
      }
      .w160 {
        width: 160px;
      }
    }
    .bottom {
      height: 40px;
      .operations {
        z-index: 10;
        height: 60px;
        position: fixed;
        left: 256px;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
        .el-button {
          width: 96px;
          letter-spacing: 4px;
        }
        .el-button + .el-button {
          margin-left: 24px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.review {
  .table {
    .el-table {
      .el-input {
        width: 80px;
        height: 24px;
        .el-input__inner {
          height: 24px;
          padding: 0 5px;
        }
      }
      .el-table__row:first-child {
        td:nth-child(3) {
          border-left: 1px solid #f2f6fc;
          border-right: 1px solid #f2f6fc;
        }
      }
    }
  }
  .ladderlist {
    .el-input {
      width: 60px;
      .el-input__inner {
        padding: 0;
        border: 0;
        border-bottom: 1px solid #e6e8ec;
        border-radius: 0;
        text-align: center;
        height: 24px;
      }
    }
  }
  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #ebeef2;
  }
}
</style>
<style>
  .review-messageBox .el-message-box__content {
    display: flex;
  }
  .review-messageBox .el-message-box__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
  }
  .review-messageBox .el-message-box__btns {
    border-top: 1px solid #eee;
    padding-top: 20px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .review-messageBox .el-message-box__content {
    padding: 20px 15px;
    height: 100px;
  }
  .review-messageBox .el-message-box__content .el-message-box__container {
    width: 50px;
  }
  .review-messageBox .el-message-box__content .el-message-box__input {
    padding-top: 0px;
    width: 100%;
  }
  .review-messageBox .el-textarea__inner {
    height: 100px;
    resize: none;
  }
</style>